import { render, staticRenderFns } from "./file.vue?vue&type=template&id=7e1f7e5a&"
import script from "./file.vue?vue&type=script&lang=js&"
export * from "./file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e1f7e5a')) {
      api.createRecord('7e1f7e5a', component.options)
    } else {
      api.reload('7e1f7e5a', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=7e1f7e5a&", function () {
      api.rerender('7e1f7e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/file.vue"
export default component.exports